export default "__VITE_ASSET__Pt_GndUW__"